import { ReactElement, Suspense, lazy } from 'react';

import { BrowserRouter, Navigate, Outlet, Route, Routes } from 'react-router-dom';

import EAppRoute from '@/types/appRoutes';

import { DefaultPartnerRedirect, FormFlowRoutes } from './components';
import { ErrorBoundaryWrapper } from './components/error-boundary-wrapper';

import { Loader } from '@/components';
import { EFeatureFlag, useFeatureFlag } from '@/shared';

const NotFoundLazy = lazy(() => import('@/pages').then((module) => ({ default: module.NotFound })));
const HomePageLazy = lazy(() => import('@/pages').then((module) => ({ default: module.HomePage })));
const ThanksPageLazy = lazy(() =>
	import('@/pages').then((module) => ({ default: module.ThanksPage })),
);

const AppRouter = (): ReactElement => {
	useFeatureFlag(EFeatureFlag.TEST_MULTIVARIATE);
	return (
		<>
			<BrowserRouter>
				<Routes>
					<Route
						element={
							<ErrorBoundaryWrapper>
								<Suspense fallback={<Loader absolute />}>
									<Outlet />
								</Suspense>
							</ErrorBoundaryWrapper>
						}
					>
						{process.env.DEFAULT_PARTNER ? (
							<>
								{FormFlowRoutes({
									withoutPartnerSlug: true,
								})}
							</>
						) : (
							<>
								<Route element={<HomePageLazy />} index />
							</>
						)}
						<Route element={<DefaultPartnerRedirect />} path={EAppRoute.Partner}>
							{FormFlowRoutes({})}
						</Route>
						<Route element={<NotFoundLazy />} path={EAppRoute.NotFound} />
						<Route element={<ThanksPageLazy />} path={EAppRoute.Thanks} />
						<Route element={<Navigate to={EAppRoute.NotFound} replace />} path="*" />
					</Route>
				</Routes>
			</BrowserRouter>
		</>
	);
};

export default AppRouter;
